<template>
  <div class="switch primary-background">
    <button
      :class="{ active: !value, 'primary-color': !value }"
      @click="$emit('input', false)"
    >
      Meine Aktivitäten
    </button>

    <button
      :class="{ active: value, 'primary-color': value }"
      @click="$emit('input', true)"
    >
      Alle Aktivitäten
    </button>
  </div>
</template>

<script>
export default {
  name: "ActivitySwitch",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.switch {
  display: inline-flex;
  border-radius: 999px;
  padding: 4px;
  width: 386px;
}

.switch button {
  width: 50%;
  border: none;
  background: transparent;
  color: white;
  padding: 10px 18px;
  border-radius: 999px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.switch button.active {
  background: white;
}
</style>
